exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".erro-404-body[data-v-577d0022]{width:100%;height:40vh;margin:0;padding:0}.erro-message[data-v-577d0022]{text-align:center;font-size:35px}", ""]);

// exports
